export const escapeNewLinesInString = (string: string) => {
	const formattedString = string.replace(/\n/g, '');
	try {
		return JSON.parse(formattedString);
	} catch (error) {
		console.error('Error parsing JSON:', error);
		return formattedString;
	}
};
